export default __webpack_public_path__ + "static/media/tick.ad8e9d93.svg";